import { TAB_IDS } from '../constants';

export const SUPPORTED_TAB_IDS = [
  TAB_IDS.HCP_TREATMENT_OPTIONS,
  TAB_IDS.HCP_SUPPORT_PROGRAMS,
];
